import { useMutation } from "@tanstack/react-query";
import { updateCustomerProfile } from "../../service/query/auth";
import { toast } from "react-toastify";

export const useUpdateCustomerProfile = ({ onSuccess }) => {
  return useMutation({
    mutationFn: updateCustomerProfile,
    onSuccess: (data) => {
      toast.success(data?.data?.message ?? "Profile updated successfully");
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message ?? "An error occurred");
    },
  });
};